<template>
  <div class="register-container__link">
    <a
      class="authorize-links__item common-link"
      @click="login">Войти</a>
    <div
      class="authorize-links__item link"
      :class="{disable: !isValid}"
      @click="$emit('send')">Зарегистрироваться
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'

  export default {
    name: 'Links',
    props: {
      isValid: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters('auth', [
        'getIsPopup'
      ])
    },
    methods: {
      ...mapMutations('auth', [
        'setPopupType'
      ]),
      login: function () {
        if (this.getIsPopup) {
          this.setPopupType('authorize')
        } else {
          window.location.href = '/personal'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Auth/Register/Links.vue